import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IUnitTriggerModel } from '@apps-common/types/portal/unit-trigger'

export const createUnitTrigger = async (model: IUnitTriggerModel): Promise<IUnitTriggerModel> =>
  axios.post(`/my-monitoring/sites/AddTrigger`, model).then((res) => res?.data?.data)

type Props = {
  model: IUnitTriggerModel
}

export const useMyMonitoringCreateUnitTrigger = (notify?: boolean, onSuccess?: (data: IUnitTriggerModel) => void) =>
  useMutation({
    mutationKey: ['createMyMonitoringUnitTrigger'],
    mutationFn: ({ model }: Props) => createUnitTrigger(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Created trigger.')
      }
    },
    onError: (error) => {
      if (notify) {
        toastError(error?.message || 'Failed to create trigger.')
      }
    },
    throwOnError: false
  })
